import { Actions } from 'vuex-smart-module';
import { ResponseStatuses } from '@/enums';
import { RequestPayload } from '@/types';
import { AxiosResponse } from 'axios';
import { ClientsService } from '../services';
import { Clients } from '../types';
import ClientsGetters from './getters';
import ClientsMutations from './mutations';
import ClientsState from './state';

const clientsService = new ClientsService();

export default class ClientsActions extends Actions<
  ClientsState,
  ClientsGetters,
  ClientsMutations,
  // eslint-disable-next-line no-use-before-define
  ClientsActions
> {
  async get_clients(storage_limit?: number) {
    this.mutations.SET_LOADING(true);

    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const filtersEmpty = this.state.organization_types.length < 1;

      const payload: RequestPayload<Clients.RequestFilters> = {
        filters: this.state.filters,
        filters_exist: !filtersEmpty,
        pagination: {
          limit: storage_limit ?? itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      const { data, meta } = await clientsService.get_clients(payload);

      this.mutations.SET_CLIENTS(data.items);

      if (filtersEmpty) {
        this.mutations.SET_CITIES(data.filters.cities);
        this.mutations.SET_ORGANIZATION_TYPES(data.filters.organization_types);
      }

      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });

      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.SET_LOADING(false);
    }
  }

  async add_new_client(client: Clients.ClientStoreRequest) {
    try {
      const data = await clientsService.add_client(client);

      if (data.code === ResponseStatuses.Success.CREATED) {
        this.dispatch('get_clients');
      }

      return data;
    } catch (error) {
      console.log(error);

      return (error as AxiosResponse).data;
    }
  }

  async active_client(id: string | number) {
    const is_active = true;

    try {
      const data = await clientsService.active_client(id, is_active);

      if (data.code === ResponseStatuses.Success.UPDATED) {
        this.dispatch('get_clients');
      }

      return data.code;
    } catch (error) {
      console.log(error);
    }
  }

  async get_clients_to_add(storage_limit?: number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.clients_to_add_table_options;
      const payload: Clients.ClientsToAddRequest = {
        filters: this.state.clients_to_add_filters,
        pagination: {
          limit: storage_limit ?? itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.SET_CLIENTS_TO_ADD_LOADING(true);

      const { data, meta } = await clientsService.get_clients_to_add(payload);

      this.mutations.SET_CLIENTS_TO_ADD(data.items);

      this.mutations.UPD_CLIENTS_TO_ADD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_CLIENTS_TO_ADD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });

      this.mutations.UPD_CLIENTS_TO_ADD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_CLIENTS_TO_ADD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_CLIENTS_TO_ADD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_CLIENTS_TO_ADD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.SET_CLIENTS_TO_ADD_LOADING(false);
    }
  }
}
